import { NgModule } from '@angular/core';
import { AuthGuard } from 'app/auth/guards/auth.guard';
import { FeatureGuard } from './guards/feature.guard';
import { AccessManageUsersGuard } from './guards/access-manage-users.guard';
import { AccessManageClientsGuard } from './guards/access-manage-clients.guard';
import { AccessReferralClaimsGuard } from './guards/access-referral-claims.guard';
import { AccessIccClaimsGuard } from './guards/access-icc-claims.guard';
import { AccessManageClientChoresGuard } from './guards/access-manage-client-chores.guard';
import { DeactivatedClientCePortalTasksGuard } from './guards/deactivated-client-ce-portal-tasks.guard';
import { AccessManageClientConfigurationsGuard } from './guards/access-manage-client-configurations.guard';
import { AccessManageProviderDataGuard } from './guards/access-manage-provider-data.guard';

@NgModule({
  providers: [
    AuthGuard,
    FeatureGuard,
    AccessManageUsersGuard,
    AccessManageClientsGuard,
    AccessManageClientChoresGuard,
    AccessReferralClaimsGuard,
    AccessIccClaimsGuard,
    AccessManageClientChoresGuard,
    DeactivatedClientCePortalTasksGuard,
    AccessManageClientConfigurationsGuard,
    AccessManageProviderDataGuard,
  ],
})
export class AuthModule {}
